// extracted by mini-css-extract-plugin
module.exports = {"opreation-button":"opreation-button-3dd6442e1a889547dab6ad8dfce9b5e1"};